import { render } from "./ShapesComponent.vue?vue&type=template&id=2aab0404&scoped=true"
import script from "./ShapesComponent.vue?vue&type=script&scoped=true&lang=js"
export * from "./ShapesComponent.vue?vue&type=script&scoped=true&lang=js"

import "./ShapesComponent.vue?vue&type=style&index=0&id=2aab0404&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aab0404"]])

export default __exports__